// Per-release "What's New" copy, surfaced two ways:
//   1. the passive feed on the Home dashboard (ENG-2105), and
//   2. the auto-surfaced post-update view when the extension bumps a minor version
//      (account.starthaven.com/?postupdate&version=…).
//
// Keyed by major.minor. ENG-2724: content now lives in the backend (release_notes table),
// editable via the Haven Admin MCP's create_release_note/update_release_note tools — no
// deploy required. See useWhatsNew() for the fetch; this module is now just the shared
// type + the pure version-matching helper.

export interface WhatsNewRelease {
  /** The major.minor this entry covers, e.g. "5.0". Patch level is intentionally omitted. */
  version: string;
  date: string;
  title: string;
  body: string;
  highlights?: string[];
}

function majorMinor(version: string): string {
  const parts = version.split(".");
  return `${parts[0] ?? "0"}.${parts[1] ?? "0"}`;
}

/**
 * Select the release entry matching a full version string (e.g. "4.10.0") by its
 * major.minor. Returns null when there's no authored entry — callers should then
 * skip the What's-New view gracefully rather than show an empty changelog.
 */
export function findReleaseForVersion(
  releases: WhatsNewRelease[],
  version: string | null | undefined,
): WhatsNewRelease | null {
  if (!version) return null;
  const mm = majorMinor(version);
  return releases.find((r) => r.version === mm) ?? null;
}
